import { useLocale, useTranslations } from 'next-intl';
import { DataList, DataListItem } from '@//components/DataList';
import { VStack } from '@//components/VStack';
import { useMarketMetadata } from '@//providers/MarketSettingsProvider';
import { formatCurrency } from '@//utils/currency';
import { WidgetHeading } from '../../../WidgetHeading';

interface BusinessLeasingProps {
  price: number;
}

export const BusinessLeasing: React.FC<BusinessLeasingProps> = ({ price }) => {
  const t = useTranslations('pages.item.financeSection.businessLeasing');
  const locale = useLocale();
  const marketMetadata = useMarketMetadata();
  return (
    <VStack gap={32}>
      <WidgetHeading>{t('label')}</WidgetHeading>
      <DataList>
        <DataListItem
          label={t('monthlyCost.label')}
          value={formatCurrency(price, {
            locale,
            currency: marketMetadata.currency,
            period: 'month',
          })}
        />
      </DataList>
    </VStack>
  );
};
